import { inject, Injectable } from "@angular/core";
import { CanMatch, Route, UrlSegment } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { filter, map, Observable } from "rxjs";

import { CatalogueSelectors } from "src/app/core/store/selectors";
import { Product } from "../models/product.model";

@Injectable({
  providedIn: "root",
})
export class CanMatchProduct implements CanMatch {
  private store = inject(Store);

  products$: Observable<Product[]>;
  products!: Product[];

  constructor() {
    this.products$ = this.store.pipe(
      select(CatalogueSelectors.getProducts),
      filter((products) => !!products.length),
      map((products) =>
        products.filter((product) => product.entity === "product"),
      ),
    );

    // this.products$.subscribe((products) => {
    //   this.products = products;
    //   // console.log({ products });
    // });
  }

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this.products$.pipe(
      map(
        (products) =>
          !!products?.filter(
            (product) => product.slug === segments[0]?.path?.replace("—", "--"),
          ).length,
      ),
    );
  }
}
